import React from 'react';
import moment from 'moment';
import {
  DateRange,
  EventBusy,
  PermContactCalendar,
  Today
} from '@material-ui/icons';

import plusMinusIcon from '../../../../images/plus-minus-icon.png';

const today = () => moment().startOf('d');

const style = {
  width: 70,
  height: 70
};

const renewalPeriods = (props) =>
  [
    {
      title: props.intl.formatMessage({
        id: 'renewal_past_due'
      }),
      icon: (
        <EventBusy
          style={{ ...style, color: '#cc2444' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#C60C30',
      expiresBefore: today()
    },
    {
      title: props.intl.formatMessage({
        id: 'renewal_zerotothree_months'
      }),
      icon: (
        <Today
          style={{ ...style, color: '#f2b826' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#F0AB00',
      expiresAfter: today(),
      expiresBefore: today().add(3, 'months')
    },
    {
      title: props.intl.formatMessage({
        id: 'renewal_threetosix_months'
      }),
      icon: (
        <DateRange
          style={{ ...style, color: '#658eb3' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#5482AB',
      expiresAfter: today().add(3, 'months'),
      expiresBefore: today().add(6, 'months')
    },
    {
      title: props.intl.formatMessage({
        id: 'renewal_sixtotwelve_months'
      }),
      icon: (
        <DateRange
          style={{ ...style, color: '#689d52' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#58923f',
      expiresAfter: today().add(6, 'months'),
      expiresBefore: today().add(12, 'months')
    },
    {
      title: props.intl.formatMessage({
        id: 'renewal_twelvetoeighteen_months'
      }),
      icon: (
        <DateRange
          style={{ ...style, color: '#3c694b' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#275937',
      expiresAfter: today().add(12, 'months'),
      expiresBefore: today().add(18, 'months')
    },
    {
      title: props.intl.formatMessage({
        id: 'renewal_eighteenmonths_plus'
      }),
      icon: (
        <PermContactCalendar
          style={{ ...style, color: '#283239' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#111C24',
      expiresAfter: today().add(18, 'months')
    },
    {
      title: `${props.intl.formatMessage({
        id: 'triggered_customers'
      })}`,
      icon: (
        <div style={{ ...style }}>
          <img
            src={plusMinusIcon}
            alt="Product Trigger"
            style={{ maxWidth: '100%', maxHeight: '100%', opacity: 0.5 }}
            className="icon-box-icon-image"
          />
        </div>
      ),
      color: '#009688',
      hasTriggerProducts: true
    }
  ].map((item) => {
    if (item.expiresBefore) {
      item.expiresBefore = item.expiresBefore.format('Y-MM-DD');
    }
    if (item.expiresAfter) {
      item.expiresAfter = item.expiresAfter.format('Y-MM-DD');
    }
    return item;
  });

export default renewalPeriods;